import type { LegacyEquipment } from './classic-legacy-api';
export type ClassicStat = LegacyEquipment['stats'][number];
const percent = new Set(['CRIT','ASPD','Cooldown reduction','Stun resist','Flame resist','Ice resist','Poison resist','Burst','Conserve','Recharge','Frenzy','Focus','Temper','Life steal','Mana steal','Resistance']);
const integer = new Set(['ATK','DEF','HP','MP','STR','AGI','INT','VIT']);
export function classicStatValue(stat: ClassicStat, enhancement: number | null = null) {
  if (stat.value === null) return 'Not recorded';
  // InventoryManager.GetEnhancedValue applies 10% per level to main options only.
  const amount = stat.value * (stat.slot.startsWith('mainOption') && enhancement !== null ? 1 + enhancement / 10 : 1);
  return `${(integer.has(stat.label) ? Math.floor(amount) : amount).toLocaleString(undefined,{maximumFractionDigits:2})}${percent.has(stat.label) ? '%' : ''}`;
}
export const classicEquipmentTitle = (item: LegacyEquipment) => `${item.name && item.name !== item.id ? item.name : item.id ? item.slot : 'Not recorded'}${item.enhancement !== null && item.enhancement > 0 ? ` +${item.enhancement}` : ''}`;
export const classicRarity = (rarity: number | null) => ['Common','Rare','Epic'][rarity ?? -1] ?? 'Not recorded';

/** EC1 BlacksmithMenu.SelectJewel maps these specific IDs to Common/Rare/Epic.
 * Other Item records have no rarity field; never infer it from material tier or price.
 */
export function classicMaterialColor(id: string | null) {
  const grade = id?.match(/^jewel_(?:courage|protection|endurance)_([cre])$/)?.[1];
  return grade ? ({c:'#ffffff',r:'#00ffff',e:'#ff7700'} as Record<string,string>)[grade] : undefined;
}
